<div class="spinner-wrapper">
    <app-spinner class="appSpinner" [message]="message"></app-spinner>
</div>